import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers, lifecycle } from 'recompose'
import { push } from 'react-router-redux'
import { page } from 'utils/trackingUtils'

import * as BillingSelectors from 'modules/billing/selectors'

import Billing from './component'

const mapStateToProps = state => ({
  plan: BillingSelectors.getPlan(state),
  coupon: BillingSelectors.getCoupon(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    push,
  }, dispatch),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      page('Onboarding Billing Setup', {
        context: 'widget-onboarding',
      })
    }
  }),
  withHandlers({
    onSkip: props => event => {
      props.actions.push('/setup/touchless/custom')
    },
  }),
)(Billing)



// WEBPACK FOOTER //
// ./src/layouts/Billing/index.js